import { fromJsonApiTopLevel } from "./deserialisers";
/**
 * A class that encapsulates all traversed and included ResourceObject instances
 * as it deserialises JSON:API responses.
 */
export class JsonApiDeserialiser {
    includes;
    constructor(initialIncludes = []) {
        this.includes = initialIncludes;
    }
    /**
     * Perform deserialisation of a response into a single object instance.
     *
     * @param {TopLevel} topLevel - the JSON:API response, to deserialise
     * @type {T} t the type of response expected - a `ResourceIdentifier` subtype
     * @return {T} the deserialised response object
     */
    deserialiseOne(topLevel) {
        const { deserialised, referents } = fromJsonApiTopLevel(topLevel, this.includes);
        this.includes = referents;
        return deserialised;
    }
    /**
     * Perform deserialisation of a response into a list of object instances.
     *
     * @param {TopLevel} topLevel - the JSON:API response, to deserialise
     * @type {T} t the type of response expected - a `ResourceIdentifier` subtype
     * @return {T[]} the deserialised response objects, as an array
     */
    deserialiseMany(topLevel) {
        const { deserialised, referents } = fromJsonApiTopLevel(topLevel, this.includes);
        this.includes = referents;
        return deserialised;
    }
    deserialise(topLevel) {
        if (topLevel && topLevel.data && Array.isArray(topLevel.data)) {
            return this.deserialiseMany(topLevel);
        }
        else if (topLevel && topLevel.data) {
            return this.deserialiseOne(topLevel);
        }
        throw new Error("No primary data to deserialise");
    }
}
/**
 * Perform deserialisation of a response into a single object instance, discarding included ResourceObjects
 *
 * @param {TopLevel} topLevel - the JSON:API response, to deserialise
 * @type {T} t the type of response expected - a `ResourceIdentifier` subtype
 * @return {T} the deserialised response object
 */
export function deserialiseOne(topLevel) {
    const { deserialised } = fromJsonApiTopLevel(topLevel);
    return deserialised;
}
/**
 * Perform deserialisation of a response into a list of object instances, discarding included ResourceObjects
 *
 * @param {TopLevel} topLevel - the JSON:API response, to deserialise
 * @type {T} t the type of response expected - a `ResourceIdentifier` subtype
 * @return {T[]} the deserialised response objects, as an array
 */
export function deserialiseMany(topLevel) {
    const { deserialised } = fromJsonApiTopLevel(topLevel);
    return deserialised;
}
